import { getAxiosError } from "../../../../utils/axiosError";
import { type AppDispatch } from "../../../Application/globaltypes/redux";
import DataService from "../../../Application/services/dataServices/typedDataService";
import {
  reqOwnerPacksLicensing,
  setOwnerPacksLicensing,
  setOwnerPacksLicensingError,
  reqPackLicenses,
  setPackLicenses,
  setPackLicensesError,
} from "./packSlice";
import { type SpPackReportFilter } from "features/Reporting/Packs/SolutionProvider/SpPackReport";

export const fetchOwnerPacksLicensing = (filter: SpPackReportFilter) => {
  return async (dispatch: AppDispatch) => {
    dispatch(reqOwnerPacksLicensing());
    try {
      const { data } = await DataService.reportingService.getOwnerPacksLicensing(filter);
      dispatch(setOwnerPacksLicensing({ data }));
    } catch (err) {
      const errorMessage = getAxiosError(err);
      dispatch(setOwnerPacksLicensingError({ errorMessage }));
    }
  };
};

export const fetchPackLicenses = (packId: number, filter: SpPackReportFilter) => {
  return async (dispatch: AppDispatch) => {
    dispatch(reqPackLicenses());
    try {
      const { data } = await DataService.reportingService.getPackLicenses(packId, filter);
      dispatch(setPackLicenses({ data }));
    } catch (err) {
      const errorMessage = getAxiosError(err);
      dispatch(setPackLicensesError({ errorMessage }));
    }
  };
};
